import _ from 'lodash'

export class ImmutableArray<T> {
    
    get value(): T[] {
        return this.arr
    }
    
    get length(): number {
        return this.arr.length
    }
    
    constructor(private arr: T[] = []) {
    }
    
    /**
     * Instantiate a new array
     */
    public set = (newArray: T[]): T[] => {
        if (_.isArray(newArray)) {
            this.arr = newArray
        }
        
        return this.arr
    }
    
    /**
     * Add one or many elements to the end of the array and returns the new array.
     */
    public push = (...elements): T[] => {
        this.arr = [...this.arr, ...elements]
        
        return this.arr
    }
    
    /**
     * Add one or many elements to the start of the array and returns the new array.
     */
    public shift = (...elements): T[] => {
        this.arr = [...elements, ...this.arr]
        
        return this.arr
    }
    
    /**
     * Merge two or more arrays.
     */
    public concat = (...args): T[] => {
        
        _.each(args, (value) => {
            if (_.isArray(value)) {
                this.arr.push(...value)
            } else {
                this.arr.push(value)
            }
        })
        
        return this.arr
    }
    
    /**
     * Create a shallow copy of the array
     */
    public clone = (): T[] => {
        return [...this.arr]
    }
    
    /**
     * Remove the last element from the array
     */
    public pop = (): any => {
        this.arr = this.arr.slice(0, -1)
        
        return this.arr
    }
    
    /**
     * Add one or many elements to the start of the array and returns the new array.
     */
    public unshift = (...elements): T[] => {
        this.arr = [...elements, ...this.arr]
        
        return this.arr
    }
    
    /**
     * Add one or many elements to the start of the array and returns the new array.
     */
    public delete = (...elements): T[] => {
        this.arr = [...elements, ...this.arr]
        
        return this.arr
    }
    
    public slide = (start?: number, end?: number) => {
        this.arr = this.arr.slice(start, end)
        return this.arr
    }
}
